var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMenuBackgroundImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189.149,
    height: 356.106,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51553"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6310"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2080",
    d: "M96.155 76.99c-.003-.039 10.18-5.73 15.562-8.001a47.545 47.545 0 0 1 11.424-3.354 18.066 18.066 0 0 0 8.405-3.075c2.411-1.839 4.892-6.678 3.148-9.66-1.916-3.287-6.427-4.978-9.762-6.194a109.471 109.471 0 0 0-12.849-3.587c-4.153-.975-8.345-1.854-12.442-3.086-2.944-.88-6.306-1.91-8.619-4.054a5.929 5.929 0 0 1-1.718-2.57 6.953 6.953 0 0 1-.19-1.849 5.964 5.964 0 0 1 .113-.77c.035-.642-1.268 2.095.101-.249a18.794 18.794 0 0 1 4.944-5.775c5.518-4.146 12.916-5.095 19.606-5.364 9.742-.387 20.61-.112 29.733 3.637 8.66 3.607 16.248 10.399 19.92 19.13a26.349 26.349 0 0 1 2.018 13.063 23.1 23.1 0 0 1-.574 3.186 19.04 19.04 0 0 1-.568 1.918c.61-1.675-.275.414-.7 1.152a29.867 29.867 0 0 1-4.889 6.186c-.752.747-.542 2.434-1.28 3.167 8.258-8.233 11.88-20.842 7.236-31.842a35.641 35.641 0 0 0-13.364-15.656c-7.255-4.807-15.288-6.253-23.827-6.814-11.104-.737-26.815-1.702-34.874 7.718a23.8 23.8 0 0 0-4.759 9.459c-1.153 5.034 4.334 7.376 8.188 8.764 7.551 2.638 15.564 3.737 23.231 5.992 4.317 1.266 16.504 4.52 14.494 11.19l.96-2.377.166-.41c-1.372 2.595-4.274 3.988-6.97 4.815-4.008 1.193-8.102 1.49-12.127 2.957a107.242 107.242 0 0 0-18.464 9.15c-.796.485-1.277 3.16-1.277 3.16Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2081",
    d: "M97.002 75.25s9.882-9.179 15.662-12.667c2.618-1.606 7.113-2.752 8.642-5.585.395-.712 1.348-2.408 1.108-3.302-.413-1.414-3.382-2.21-4.546-2.672-8.416-3.326-17.215-5.567-25.465-9.351-4.745-2.18-13.422-6.23-11.334-12.905l-.652 1.614c1.175-2.91 4.472-6.219 6.685-8.493a33.816 33.816 0 0 1 11.303-7.904 25.41 25.41 0 0 1 15.132-1.228c6.632 1.47 12.196 5.481 18.056 8.683 5.162 2.818 10.491 5.384 15.46 8.544 3.443 2.198 7.008 4.838 8.81 8.622s1.382 8.594-.222 12.436c-2.857 6.805-7.067 13.13-10.566 19.63s-7.15 13.463-3.02 20.484c-.339-.577 1.642-2.543 1.276-3.159a13.039 13.039 0 0 1-2.076-6.465 14.163 14.163 0 0 1 .457-3.223 10.063 10.063 0 0 1 .334-1.093c-.438 1.247-.127.314 0 0 .456-.941.935-1.873 1.422-2.802 3.985-7.526 8.677-14.754 11.963-22.631 2.03-4.908 4.198-10.39 2.053-15.663-2.287-5.687-8.43-9.031-13.476-11.895-3.674-2.047-7.429-3.939-11.105-5.977-4.233-2.31-8.256-5.09-12.72-7.015a26.54 26.54 0 0 0-21.669.05 37.914 37.914 0 0 0-13.757 11.626c-2.228 2.916-5.295 7.097-5.365 10.959-.132 12.838 43.283 18.368 41.66 23.498l1.282-3.172c-.567 1.056-2.012 1.615-3.003 2.143-2.22 1.175-4.436 2.324-6.554 3.69C107.44 63.377 95.598 75.1 95.598 75.1Z",
    fill: "#eceff1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2072",
    d: "m16.754 79.714 38.954-2.525.028.001 25.522-1.651.02-.002 1.706-.117.009.003 5.719-.37.008.003 1.013-.069 3.735-.244.676-.05 2.567-.168.516-.026 1.142-.072-.342.519-32.395 49.54-9.78-.35-17.148-.628-.058.004-18.348-.672-.057.008-12.626-.463 1.893-8.817h0l.048-.28 2.84-13.225.008-.044 3.123-14.574Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2077",
    d: "M12.404 100.018Z",
    fill: "#ffa700",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 256",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M65.636 124.488 16.755 79.715"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 257",
    fill: "#eceff1",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.614 122.384 90.754-47.958"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17172",
    d: "M43.238 103.818c86.457-23.166 240.35 19.236 65.35 73.992s100.133 74.824 33.908 178.025",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    opacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuBackgroundImage);
export default __webpack_public_path__ + "static/media/mobile-menu-background-image.13b0ab9f875d09bdd9b67dc1d117a5f3.svg";
export { ForwardRef as ReactComponent };